import { ArrowUp } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from '@/i18n'
import { useAppStore } from '@/store'

/**
 * Message composer: autosizing-ish textarea (Enter = send, Shift+Enter =
 * newline) and the round send button, idle in grey until there is something
 * to send. That is the whole composer in Putra's design (2026-10-16 update):
 * the disabled "coming soon" mic that used to sit beside the send button is
 * gone, since a control that cannot be used is a promise, not a control.
 */
const HelpAgentInput = () => {
  const { t } = useTranslation('help_agent')
  const location = useLocation()
  const helpInputValue = useAppStore((s) => s.helpInputValue)
  const setHelpInputValue = useAppStore((s) => s.setHelpInputValue)
  const helpIsStreaming = useAppStore((s) => s.helpIsStreaming)
  const sendHelpMessage = useAppStore((s) => s.sendHelpMessage)

  const canSend = helpInputValue.trim() !== '' && !helpIsStreaming

  const submit = () => {
    if (!canSend) return
    void sendHelpMessage(helpInputValue.trim(), location.pathname)
  }

  return (
    <div className="p-4">
      <div className="flex flex-col gap-1 rounded-xl border border-gray-200 bg-white px-3 py-2 focus-within:ring-1 focus-within:ring-ring dark:border-dark-border dark:bg-dark-card">
        <textarea
          rows={2}
          value={helpInputValue}
          placeholder={t('input.placeholder')}
          onChange={(event) => setHelpInputValue(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && !event.shiftKey) {
              event.preventDefault()
              submit()
            }
          }}
          className="max-h-28 w-full resize-none bg-transparent text-sm text-gray-900 outline-none placeholder:text-muted-foreground dark:text-dark-text"
        />
        <div className="flex items-center justify-end">
          <button
            type="button"
            aria-label={t('input.send')}
            disabled={!canSend}
            onClick={submit}
            className="flex size-8 items-center justify-center rounded-full bg-brand text-white transition-colors hover:bg-brand-hover disabled:bg-gray-200 disabled:text-gray-400 dark:disabled:bg-dark-accent dark:disabled:text-muted-foreground"
          >
            <ArrowUp className="size-4" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default HelpAgentInput
